export default {
  title: 'Drukowanie paragonów',
  sections: {
    destination: 'Paragony drukowane na',
  },
  printers: {
    inner: {
      title: 'Wbudowana drukarka',
    },
    external: {
      title: 'Zewnętrzna drukarka',
      width_unset: 'Szerokość papieru nie ustawiona',
      connect_hint: 'Podłącz drukarkę, aby jej używać',
      disconnect_confirm: 'Odłączyć tę drukarkę?',
      disconnect_confirm_description: 'Będziesz musiał ją skonfigurować ponownie.',
      disconnect_confirm_ok: 'Tak, odłącz',
    },
  },
  // One block per printer state. `label` is the printer row's sub-line segment;
  // `title` and `description` are the status alert. `{{name}}` is the printer's name.
  statuses: {
    connected: {
      label: 'Gotowa',
      title: 'Gotowa do druku',
      description: '{{name}}',
    },
    paper_near_end: {
      label: 'Mało papieru',
      title: 'Papier prawie wyczerpany',
      description: 'Wymień rolkę wkrótce. Drukowanie jest kontynuowane.',
    },
    busy: {
      label: 'Zajęta',
      title: 'Drukarka jest zajęta',
      description: '{{name}} kończy inne zadanie.',
    },
    not_configured: {
      label: 'Nie skonfigurowano',
      title: 'Nie skonfigurowano',
      description: '{{name}} wymaga konfiguracji przed drukowaniem.',
    },
    offline: {
      label: 'Offline',
      title: 'Nie drukuje',
      description: '{{name}} jest offline. Nowe zamówienia nie są drukowane.',
      // Used when auto-print is off — nothing is silently failing to print.
      title_idle: 'Offline',
      description_idle: '{{name}} nie jest połączona.',
    },
    cover_open: {
      label: 'Pokrywa otwarta',
      title: 'Pokrywa jest otwarta',
      description: 'Zamknij pokrywę drukarki, aby wznowić drukowanie.',
    },
    paper_empty: {
      label: 'Brak papieru',
      title: 'Brak papieru',
      description: 'Wymień rolkę, aby wznowić drukowanie.',
    },
    wrong_paper: {
      label: 'Zły papier',
      title: 'Zły papier',
      description: 'Załadowana rolka nie pasuje do skonfigurowanej szerokości papieru.',
    },
    cutter_error: {
      label: 'Błąd noża',
      title: 'Błąd noża',
      description: 'Sprawdź nóż pod kątem zablokowanego papieru i spróbuj ponownie.',
    },
    overheat: {
      label: 'Przegrzanie',
      title: 'Drukarka za gorąca',
      description: 'Poczekaj, aż {{name}} ostygnie, przed kolejnym drukowaniem.',
    },
    error: {
      label: 'Błąd',
      title: 'Błąd drukarki',
      description: '{{name}} zgłosiła błąd i wymaga uwagi.',
    },
    connecting: {
      label: 'Łączenie…',
      title: 'Łączenie…',
      description: '{{name}}',
    },
    disconnected: {
      label: 'Nie połączono',
      title: 'Nie połączono',
      description: '{{name}} nie jest połączona.',
    },
  },
  form: {
    auto_print: {
      label: 'Drukuj nowe zamówienia automatycznie',
      not_ready: 'Autodruk jest włączony, ale zewnętrzna drukarka nie jest gotowa. Zamówienia nie będą drukowane.',
    },
    print_copies: {
      label: 'Kopie na zamówienie',
      hint: 'Włącz autodruk, aby ustawić kopie',
      decrease: 'Zmniejsz liczbę kopii',
      increase: 'Zwiększ liczbę kopii',
    },
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
  },
  buttons: {
    test_print: 'Druk testowy',
    configure_external: 'Konfiguruj',
    connect_external: 'Połącz drukarkę',
    disconnect_external: 'Rozłącz',
    retry_connection: 'Ponów połączenie',
    cancel: 'Anuluj',
  },
};
